<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col>
            <filter-card :get-data-list="filterDataList" />
          </b-col>
          <b-col
            v-if="isArchive || canAdd || canArchiveList"
            cols="12"
            md="auto"
            style="padding-top: 20px"
          >
            <b-button
              v-if="isArchive"
              variant="outline-primary"
              :to="basePath"
            >
              <FeatherIcon icon="ListIcon" /> Listeye Dön
            </b-button>
            <template v-else>
              <b-button
                v-if="canArchiveList"
                variant="outline-primary"
                :class="{ 'mr-1': canAdd }"
                :to="basePath + '/archive'"
              >
                <FeatherIcon icon="ArchiveIcon" /> Arşiv
              </b-button>
              <b-button
                v-if="canAdd"
                variant="primary"
                :to="basePath + '/add'"
              >
                <FeatherIcon icon="PlusIcon" /> Oluştur
              </b-button>
            </template>
          </b-col>
        </b-row>
      </b-card-body>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="dataList"
        striped
        :busy="loading"
        :empty-text="emptyText"
        :show-empty="!!emptyText"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle" />
            <strong class="ml-2">Yükleniyor...</strong>
          </div>
        </template>
        <template #cell(image)="data">
          <div>
            <b-link
              :to="basePath + '/view/' + data.item.id"
              class="text-body"
            >
              <b-img
                v-if="data.item.thumb"
                :src="data.item.thumb"
                width="100"
                fluid
                thumbnail
              />
              <image-not-found v-else />
            </b-link>
          </div>
        </template>
        <template #cell(title)="data">
          <b-link
            :to="basePath + '/view/' + data.item.id"
            class="text-body d-block"
          >
            <div v-if="data.item.pcode">
              <b-badge
                variant="light-primary"
                size="sm"
              >
                {{ data.item.pcode }}
              </b-badge>
            </div>
            {{ data.item.title }}
            <div
              v-if="data.item.departments"
            >
              <b-badge variant="light-info">
                <feather-icon icon="FolderIcon" />
                {{ data.item.departments }}
              </b-badge>
            </div>
          </b-link>
        </template>
        <template #cell(brandModel)="data">
          <div v-if="data.item.brand || data.item.model">
            <div
              v-if="data.item.brand"
              class="font-weight-bold"
            >
              {{ data.item.brand }}
            </div>
            <div
              v-if="data.item.model"
              class="text-muted"
            >
              {{ data.item.model }}
            </div>
          </div>
          <div v-else>
            -
          </div>
        </template>
        <template #cell(category)="data">
          <div>
            {{ data.item.category? data.item.category : '-' }}
          </div>
        </template>
        <template #cell(teams)="data">
          <b-badge variant="light-primary">
            <feather-icon icon="UsersIcon" />
            {{ data.item.teams }}
          </b-badge>
        </template>
        <template #cell(control)="data">
          <div class="text-right">
            <template v-if="isArchive">
              <b-button
                size="sm"
                variant="outline-primary"
                :to="basePath + '/view/' + data.item.id"
              >
                <feather-icon icon="EyeIcon" />
                Görüntüle
              </b-button>
              <b-button
                v-if="canArchiveManage"
                size="sm"
                variant="outline-success"
                class="ml-50"
                @click="restoreItem(data.item.id)"
              >
                <feather-icon icon="RotateCcwIcon" />
                Arşivden Geri Yükle
              </b-button>
            </template>
            <list-buttons
              v-else
              :view-action="basePath + '/view/' + data.item.id"
              :edit-action="basePath + '/edit/' + data.item.id"
              :delete-action="removeData"
              :data-id="data.item.id"
              :archive-action="canArchiveManage ? archiveItem : null"
            />
          </div>
        </template>
      </b-table>
      <b-card-footer>
        <b-pagination
          v-if="dataCounts > perPage"
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BBadge, BImg, BSpinner, BLink, BRow, BCol,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { hasPackageLimit } from '@/libs/packageLimits'
import listPagination from '@/mixins/listPagination'
import archiveActions from '@/mixins/archiveActions'
import ImageNotFound from '@/layouts/components/common/ImageNotFound.vue'
import FilterCard from '@/views/Products/Components/FilterCard.vue'

const tableName = 'products'
export default {
  name: 'Index',
  components: {
    BImg,
    ImageNotFound,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    ListButtons,
    BBadge,
    BSpinner,
    BLink,
    BRow,
    BCol,
    FilterCard,
  },
  mixins: [listPagination, archiveActions],
  data() {
    return {
      basePath: '/app/products',
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'image',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 pr-0 text-nowrap pt-1 pl-1 pb-1',
        },
        {
          key: 'title',
          label: 'ÜRÜN ADI',
        },
        {
          key: 'brandModel',
          label: 'MARKA / MODEL',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
        },
        {
          key: 'category',
          label: 'ÜRÜN KATEGORİSİ',
          thClass: 'width-300 text-nowrap',
          tdClass: 'width-300 text-nowrap',
        },
        {
          key: 'teams',
          label: 'Ekip',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.pcode AS pcode`,
          `${tableName}.brand AS brand`,
          `${tableName}.model AS model`,
          `${tableName}.created AS created`,
          'origins.title AS origin',
          'product_categories.title AS category',
          'departments.title AS departments',
          'teams.title AS teams',
          'users.name AS users',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
        archived: !!this.$route.meta.archived,
      },
    }
  },
  computed: {
    isArchive() {
      return !!this.$route.meta.archived
    },
    canArchiveList() {
      return this.$can('read', 'PRODUCTS_ARCHIVE')
    },
    canArchiveManage() {
      return this.$can('read', 'PRODUCTS_ARCHIVE_MANAGE')
    },
    canAdd() {
      return this.$can('read', 'PRODUCTS_ADD') && hasPackageLimit('PRODUCTS_MANAGE')
    },
    loading() {
      return this.$store.getters['products/loading']
    },
    emptyText() {
      if (this.loading === true) {
        return 'Lütfen bekleyiniz...'
      }
      if (this.dataList.length === 0) {
        return 'İçerik bulunamadı.'
      }
      return null
    },
    dataList() {
      return this.$store.getters['products/dataList']
    },
    dataCounts() {
      return this.$store.getters['products/dataCounts']
    },
    saveData() {
      return this.$store.getters['products/dataSaveStatus']
    },
    filterParams() {
      return this.$store.getters['products/filterParams']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.dataQuery.start = (this.currentPage - 1) * this.perPage
      const kw = (this.filterParams.keywords || '').trim()
      if (kw) {
        this.dataQuery.or_like = {
          'products.title': kw,
          'products.pcode': kw,
        }
      } else {
        delete this.dataQuery.or_like
      }

      const where = {}
      if (this.filterParams.id_product_categories) {
        where['products.id_product_categories'] = this.filterParams.id_product_categories
      }
      if (this.filterParams.id_origins) {
        where['products.id_origins'] = this.filterParams.id_origins
      }
      if (Object.keys(where).length) {
        this.dataQuery.where = where
      } else {
        delete this.dataQuery.where
      }

      const brand = (this.filterParams.brand || '').trim()
      const model = (this.filterParams.model || '').trim()
      const like = {}
      if (brand) {
        like['products.brand'] = brand
      }
      if (model) {
        like['products.model'] = model
      }
      if (Object.keys(like).length) {
        this.dataQuery.like = like
      } else {
        delete this.dataQuery.like
      }

      this.$store.dispatch('products/getDataList', this.dataQuery)
        .then(() => this.checkPageRange())
    },
    archiveItem(id) {
      this.changeArchive('products', id, true).then(res => {
        if (res) {
          this.getDataList()
        }
      })
    },
    restoreItem(id) {
      this.changeArchive('products', id, false).then(res => {
        if (res) {
          this.getDataList()
        }
      })
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('products/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
